import { useState } from "react";
import "./CongNghiep.css";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,

  PieChart,
  Pie,
  Cell,
} from "recharts";

const chartData = [
  { month: "Tháng 1", "Năm 2023": 150, "Năm 2024": 180 },
  { month: "Tháng 2", "Năm 2023": 170, "Năm 2024": 200 },
  { month: "Tháng 3", "Năm 2023": 180, "Năm 2024": 210 },
  { month: "Tháng 4", "Năm 2023": 200, "Năm 2024": 240 },
  { month: "Tháng 5", "Năm 2023": 260, "Năm 2024": 300 },
  { month: "Tháng 6", "Năm 2023": 180, "Năm 2024": 220 },
  { month: "Tháng 7", "Năm 2023": 170, "Năm 2024": 210 },
  { month: "Tháng 8", "Năm 2023": 190, "Năm 2024": 230 },
  { month: "Tháng 9", "Năm 2023": 180, "Năm 2024": 220 },
  { month: "Tháng 10", "Năm 2023": 200, "Năm 2024": 240 },
  { month: "Tháng 11", "Năm 2023": 190, "Năm 2024": 230 },
  { month: "Tháng 12", "Năm 2023": 200, "Năm 2024": 250 }
];


const pieData = [
  {
    name: "Chế biến, chế tạo",
    value: 168.45,
    percent: 65.6,
    color: "#2563EB"
  },
  {
    name: "Sản xuất & phân phối điện",
    value: 32.12,
    percent: 12.5,
    color: "#10B981"
  },
  {
    name: "Cung cấp nước, xử lý rác thải",
    value: 18.75,
    percent: 7.3,
    color: "#F59E0B"
  },
  {
    name: "Khai khoáng",
    value: 15.86,
    percent: 6.2,
    color: "#7C3AED"
  },
  {
    name: "Khác",
    value: 21.60,
    percent: 8.4,
    color: "#C4B5FD"
  }
];

function CongNghiep() {
  
  const [showDropdown, setShowDropdown] = useState(false);

const [showIndicatorModal, setShowIndicatorModal] = useState(false);

const [showAddIndicatorModal, setShowAddIndicatorModal] = useState(false);
  
    return (
    <div className="bao-cao-cong-nghiep-page">

      {/* HEADER */}
      <div className="page-header">
        <div>
          <h1>Báo cáo công nghiệp</h1>
          <div className="breadcrumb">
            Trang chủ &gt; Công nghiệp &gt; Báo cáo công nghiệp
          </div>
        </div>

        <button className="guide-btn">
          Hướng dẫn
        </button>
      </div>

{/* FILTER */}
<div className="filter-card">

    <div className="filter-grid">

        <div className="form-group">
            <label>
                Kỳ báo cáo <span>*</span>
            </label>

            <select>
                <option>Tháng 05/2024</option>
            </select>
        </div>

        <div className="form-group">
            <label>
                Từ ngày <span>*</span>
            </label>

            <input
                type="date"
                defaultValue="2024-05-01"
            />
        </div>

        <div className="form-group">
            <label>
                Đến ngày <span>*</span>
            </label>

            <input
                type="date"
                defaultValue="2024-05-31"
            />
        </div>

        <div className="form-group">
            <label>
                Đơn vị báo cáo <span>*</span>
            </label>

            <select>
                <option>Xã Mỹ Đức</option>
            </select>
        </div>

        <div className="filter-btn-wrapper">
            <button className="load-btn">
                Lấy dữ liệu
            </button>
        </div>

    </div>

</div>

      {/* CONTENT */}
      <div className="report-layout">

        {/* LEFT */}
        <div className="main-content">

{/* KPI */}
<div className="kpi-grid">

    <div className="kpi-card">

        <div className="kpi-icon blue">
            <i className="fa-solid fa-industry"></i>
        </div>

        <div className="kpi-content">
            <h4>Giá trị SXCN (tỷ đồng)</h4>
            <h2>256,78</h2>
            <p>↑ 8,65% so với kỳ trước</p>
        </div>

    </div>

    <div className="kpi-card">

        <div className="kpi-icon green">
            <i className="fa-solid fa-chart-line"></i>
        </div>

        <div className="kpi-content">
            <h4>Chỉ số SXCN (IIP %)</h4>
            <h2>112,35</h2>
            <p>↑ 6,25% so với kỳ trước</p>
        </div>

    </div>

    <div className="kpi-card">

        <div className="kpi-icon orange">
            <i className="fa-solid fa-users"></i>
        </div>

        <div className="kpi-content">
            <h4>Số doanh nghiệp</h4>
            <h2>85</h2>
            <p>↑ 3 doanh nghiệp</p>
        </div>

    </div>

    <div className="kpi-card">

        <div className="kpi-icon purple">
            <i className="fa-solid fa-gear"></i>
        </div>

        <div className="kpi-content">
            <h4>Số lao động (người)</h4>
            <h2>2.450</h2>
            <p>↑ 4,7% so với kỳ trước</p>
        </div>

    </div>

</div>

          {/* CHART */}
          <div className="chart-grid">

            <div className="card">

    <div className="chart-header">

        <h3>
            GIÁ TRỊ SẢN XUẤT CÔNG NGHIỆP
            <span>(Tỷ đồng)</span>
        </h3>

    </div>

    <div className="bar-chart-wrapper">

        <ResponsiveContainer
            width="100%"
            height={260}
        >
            <BarChart data={chartData}>

                <XAxis dataKey="month" />

                <YAxis />

                <Tooltip />

                <Legend />

                <Bar
                    dataKey="Năm 2023"
                    fill="#9EC5FE"
                    radius={[4,4,0,0]}
                />

                <Bar
                    dataKey="Năm 2024"
                    fill="#2563EB"
                    radius={[4,4,0,0]}
                />

            </BarChart>
        </ResponsiveContainer>

    </div>

</div>

            <div className="card">

    <div className="chart-header">
        <h3>
            CƠ CẤU GIÁ TRỊ SXCN THEO NGÀNH
            <span>(Tỷ đồng)</span>
        </h3>
    </div>

    <div className="pie-layout">

        {/* DONUT */}

        <div className="pie-chart-area">

            <ResponsiveContainer
                width="100%"
                height={240}
            >
                <PieChart>

                    <Pie
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={85}
                        paddingAngle={2}
                        dataKey="value"
                    >
                        {pieData.map((entry, index) => (
                            <Cell
                                key={index}
                                fill={entry.color}
                            />
                        ))}
                    </Pie>

                </PieChart>

            </ResponsiveContainer>

            <div className="donut-center">
                <div className="donut-value">
                    256,78
                </div>

                <div className="donut-unit">
                    Tỷ đồng
                </div>
            </div>

        </div>

        {/* LEGEND */}

        <div className="pie-legend">

            {pieData.map((item,index)=>(
                <div
                    key={index}
                    className="legend-item"
                >

                    <div className="legend-left">

                        <span
                            className="legend-dot"
                            style={{
                                background:item.color
                            }}
                        />

                        <span>
                            {item.name}
                        </span>

                    </div>

                    <strong className="legend-value">
    {item.value.toFixed(2).replace(".", ",")}
    {" "}
    ({item.percent.toFixed(1).replace(".", ",")}%)
</strong>

                </div>
            ))}

        </div>

    </div>

</div>

          </div>

{/* ACTION BAR */}
<div className="table-action-bar">

    <button
        className="primary-btn"
        onClick={() => setShowDropdown(!showDropdown)}
    >
        + Thêm số liệu
    </button>

{showDropdown && (
            <div className="option-dropdown">

                <div
                    className="option-item"
                    onClick={()=>{
                        setShowAddIndicatorModal(true);
                        setShowDropdown(false);
                    }}
                >
                    Thêm số liệu cho kỳ báo cáo
                </div>

                <div
                    className="option-item"
                    onClick={()=>{
                        setShowIndicatorModal(true);
                        setShowDropdown(false);
                    }}
                >
                    Quản lý chỉ tiêu
                </div>

            </div>
        )}

    <div className="option-wrapper">

        <button
            className="outline-btn"
            // onClick={() => setShowDropdown(!showDropdown)}
        >
            <i className="fa-solid fa-gear"></i>
            Tùy chọn
        </button>

        {showDropdown && (
            <div className="option-dropdown">

                <div
                    className="option-item"
                    onClick={()=>{
                        setShowAddIndicatorModal(true);
                        setShowDropdown(false);
                    }}
                >
                    Thêm số liệu cho kỳ báo cáo
                </div>

                <div
                    className="option-item"
                    onClick={()=>{
                        setShowIndicatorModal(true);
                        setShowDropdown(false);
                    }}
                >
                    Quản lý chỉ tiêu
                </div>

            </div>
        )}

    </div>

</div>

{/* TABLE */}
<div className="report-table-card">

    <div className="report-table-header">

        <h3>
            TÌNH HÌNH SẢN XUẤT CÔNG NGHIỆP
        </h3>

        <span>
            Đơn vị tính: Tỷ đồng
        </span>

    </div>

    <div className="table-wrapper">

        <table className="report-table">

            <thead>

                <tr>
                    <th style={{width:"60px"}}>STT</th>
                    <th>Chỉ tiêu</th>
                    <th>Tháng 05/2024</th>
                    <th>Tháng 04/2024</th>
                    <th>Lũy kế từ đầu năm</th>
                    <th>So với kỳ trước (%)</th>
                    <th>So với cùng kỳ (%)</th>
                </tr>

            </thead>

            <tbody>

                <tr>
                    <td>1</td>
                    <td className="text-left">
                        Giá trị SXCN (theo giá hiện hành)
                    </td>
                    <td>256,78</td>
                    <td>236,34</td>
                    <td>1.178,65</td>
                    <td className="up-value">↑ 8,65%</td>
                    <td className="up-value">↑ 10,42%</td>
                </tr>

                <tr>
                    <td>2</td>
                    <td className="text-left">
                        Giá trị SXCN (theo giá so sánh)
                    </td>
                    <td>198,45</td>
                    <td>185,62</td>
                    <td>912,34</td>
                    <td className="up-value">↑ 6,92%</td>
                    <td className="up-value">↑ 8,35%</td>
                </tr>

                <tr>
                    <td>3</td>
                    <td className="text-left">
                        Chỉ số SXCN (IIP %)
                    </td>
                    <td>112,35</td>
                    <td>105,72</td>
                    <td>109,18</td>
                    <td className="up-value">↑ 6,25%</td>
                    <td className="up-value">↑ 9,18%</td>
                </tr>

                <tr>
                    <td>4</td>
                    <td className="text-left">
                        Số doanh nghiệp
                    </td>
                    <td>85</td>
                    <td>82</td>
                    <td>-</td>
                    <td className="up-value">↑ 3,66%</td>
                    <td className="up-value">↑ 5,59%</td>
                </tr>

                <tr>
                    <td>5</td>
                    <td className="text-left">
                        Số lao động (người)
                    </td>
                    <td>2.450</td>
                    <td>2.340</td>
                    <td>-</td>
                    <td className="up-value">↑ 4,70%</td>
                    <td className="up-value">↑ 6,05%</td>
                </tr>

            </tbody>

        </table>

    </div>

</div>

{/* NOTE + FILE */}
<div className="bottom-grid">

    {/* GHI CHÚ */}
    <div className="note-card">

        <div className="section-title">
            Ghi chú
        </div>

        <div className="note-wrapper">

            <textarea
                maxLength={500}
                placeholder="Nhập ghi chú (nếu có)..."
                className="note-textarea"
            />

            <span className="note-counter">
                0/500
            </span>

        </div>

    </div>

    {/* FILE */}
    <div className="upload-card">

    <div className="section-title">
        Tài liệu đính kèm
    </div>

    <div className="upload-area">

        <div className="upload-top">

            <div className="upload-icon">
                <i className="fa-solid fa-cloud-arrow-up"></i>
            </div>

            <div className="upload-text">
                Kéo thả file vào đây hoặc
            </div>

            <label className="choose-file-btn">
                Chọn file
                <input type="file" hidden />
            </label>

        </div>

        <div className="upload-format">
            Định dạng: .pdf, .doc, .docx, .xls, .xlsx
        </div>

        <div className="upload-size">
            Dung lượng tối đa 20MB
        </div>

    </div>

</div>

</div>

          {/* ACTION */}
          <div className="action-row">

            <button className="outline-btn">
              Quay lại
            </button>

            <button className="outline-btn">
              Lưu nháp
            </button>

            <button className="primary-btn">
              Gửi báo cáo
            </button>

          </div>

        </div>

{/* RIGHT */}
<div className="report-sidebar">

    {/* THÔNG TIN */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
            THÔNG TIN KỲ BÁO CÁO
        </h3>

        <div className="sidebar-info-row">
            <span>Kỳ báo cáo</span>
            <strong>Tháng 05/2024</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Loại báo cáo</span>
            <strong>Báo cáo công nghiệp</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Ngày tạo</span>
            <strong>02/06/2024 09:15</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Hạn gửi</span>
            <strong>05/06/2024 23:59</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Trạng thái</span>

            <span className="status-badge warning">
                Chưa gửi
            </span>
        </div>

    </div>

    {/* TIẾN ĐỘ */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
            TIẾN ĐỘ BÁO CÁO CÔNG NGHIỆP
        </h3>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot active"></span>
                <span>Báo cáo SX công nghiệp</span>
            </div>

            <span className="status-badge warning">
                Chưa gửi
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo cụm công nghiệp</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo khuyến công</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo cơ khí - chế tạo</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

    </div>

    {/* HƯỚNG DẪN */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
            TÀI LIỆU HƯỚNG DẪN
        </h3>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn lập báo cáo công nghiệp</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Mẫu báo cáo công nghiệp (Excel)</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn báo cáo SX công nghiệp</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn báo cáo cụm công nghiệp</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn báo cáo khuyến công</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-footer">
            Xem tất cả
            <i className="fa-solid fa-arrow-right"></i>
        </div>

    </div>

{/* MODAL QUẢN LÝ CHỈ TIÊU */}

{showIndicatorModal && (

<div className="modal-overlay">

    <div className="indicator-modal">

        <div className="modal-header">

            <h3>Quản lý chỉ tiêu</h3>

            <button
                className="close-btn"
                onClick={() => setShowIndicatorModal(false)}
            >
                ×
            </button>

        </div>

        <div className="modal-body">

    {/* TAB */}
    <div className="indicator-tabs">

        <button className="indicator-tab active">
            Danh sách chỉ tiêu
        </button>

        <button className="indicator-tab">
            Nhóm chỉ tiêu
        </button>

    </div>

    {/* ACTION */}
    <div className="modal-top-action">

        <div className="search-box">

            <i className="fa-solid fa-magnifying-glass"></i>

            <input
                type="text"
                placeholder="Tìm kiếm chỉ tiêu..."
                className="search-input"
            />

        </div>

        <button
            className="primary-btn"
            onClick={() => {
                setShowIndicatorModal(false);
                setShowAddIndicatorModal(true);
            }}
        >
            + Thêm chỉ tiêu
        </button>

    </div>

    <table className="indicator-table">

        <thead>
            <tr>
                <th>STT</th>
                <th>Tên chỉ tiêu</th>
                <th>Đơn vị tính</th>
                <th>Nhóm chỉ tiêu</th>
                <th>Bắt buộc</th>
                <th>Trạng thái</th>
                <th>Thao tác</th>
            </tr>
        </thead>

        <tbody>

            <tr>
                <td>1</td>
                <td>Giá trị SXCN (theo giá hiện hành)</td>
                <td>Tỷ đồng</td>
                <td>Sản xuất công nghiệp</td>

                <td>
                    <input
                        type="checkbox"
                        checked
                        readOnly
                    />
                </td>

                <td>
                    <span className="status-active">
                        Đang áp dụng
                    </span>
                </td>

                <td>
                    <div className="action-buttons">

                        <button className="icon-btn edit-btn">
                            <i className="fa-solid fa-pen"></i>
                        </button>

                        <button className="icon-btn delete-btn">
                            <i className="fa-regular fa-trash-can"></i>
                        </button>

                    </div>
                </td>
            </tr>

            <tr>
                <td>2</td>
                <td>Quản lý SXCN (theo giá so sánh)</td>
                <td>Tỷ đồng</td>
                <td>Sản xuất công nghiệp</td>

                <td>
                    <input
                        type="checkbox"
                        checked
                        readOnly
                    />
                </td>

                <td>
                    <span className="status-active">
                        Đang áp dụng
                    </span>
                </td>

                <td>
                    <div className="action-buttons">

                        <button className="icon-btn edit-btn">
                            <i className="fa-solid fa-pen"></i>
                        </button>

                        <button className="icon-btn delete-btn">
                            <i className="fa-regular fa-trash-can"></i>
                        </button>

                    </div>
                </td>
            </tr>

            <tr>
                <td>3</td>
                <td>Chỉ số SXCN (IPI %)</td>
                <td>%</td>
                <td>Sản xuất công nghiệp</td>

                <td>
                    <input
                        type="checkbox"
                        checked
                        readOnly
                    />
                </td>

                <td>
                    <span className="status-active">
                        Đang áp dụng
                    </span>
                </td>

                <td>
                    <div className="action-buttons">

                        <button className="icon-btn edit-btn">
                            <i className="fa-solid fa-pen"></i>
                        </button>

                        <button className="icon-btn delete-btn">
                            <i className="fa-regular fa-trash-can"></i>
                        </button>

                    </div>
                </td>
            </tr>

            <tr>
    <td>4</td>
    <td>Số doanh nghiệp</td>
    <td>Doanh nghiệp</td>
    <td>Doanh nghiệp</td>

    <td>
        <input
            type="checkbox"
            readOnly
        />
    </td>

    <td>
        <span className="status-active">
            Đang áp dụng
        </span>
    </td>

    <td>
        <div className="action-buttons">

            <button className="icon-btn edit-btn">
                <i className="fa-solid fa-pen"></i>
            </button>

            <button className="icon-btn delete-btn">
                <i className="fa-regular fa-trash-can"></i>
            </button>

        </div>
    </td>
</tr>

<tr>
    <td>5</td>
    <td>Số lao động (người)</td>
    <td>Người</td>
    <td>Lao động</td>

    <td>
        <input
            type="checkbox"
            readOnly
        />
    </td>

    <td>
        <span className="status-active">
            Đang áp dụng
        </span>
    </td>

    <td>
        <div className="action-buttons">

            <button className="icon-btn edit-btn">
                <i className="fa-solid fa-pen"></i>
            </button>

            <button className="icon-btn delete-btn">
                <i className="fa-regular fa-trash-can"></i>
            </button>

        </div>
    </td>
</tr>

        </tbody>

    </table>

    {/* PAGINATION */}

    <div className="table-pagination">

        <button>
            <i className="fa-solid fa-chevron-left"></i>
        </button>

        <button className="active-page">
            1
        </button>

        <button>
            <i className="fa-solid fa-chevron-right"></i>
        </button>

    </div>

</div>

    </div>

</div>

)}

{/* MODAL THÊM CHỈ TIÊU */}

{showAddIndicatorModal && (

<div className="modal-overlay">

    <div className="add-indicator-modal">

        <div className="modal-header">

            <h3>Thêm chỉ tiêu mới</h3>

            <button
                className="close-btn"
                onClick={() => setShowAddIndicatorModal(false)}
            >
                ×
            </button>

        </div>

<div className="modal-form">

    <div className="form-row">

        <div className="form-group">
            <label>
                Tên chỉ tiêu <span className="required">*</span>
            </label>
            <input
                type="text"
                placeholder="Nhập tên chỉ tiêu"
            />
        </div>

        <div className="form-group">
            <label>
                Đơn vị tính <span className="required">*</span>
            </label>
            <select>
                <option>Chọn đơn vị tính</option>
                <option>Tỷ đồng</option>
                <option>%</option>
                <option>Người</option>
            </select>
        </div>

    </div>

    <div className="form-row">

        <div className="form-group">
            <label>
                Nhóm chỉ tiêu <span className="required">*</span>
            </label>
            <select>
                <option>Chọn nhóm chỉ tiêu</option>
                <option>Sản xuất công nghiệp</option>
                <option>Doanh nghiệp</option>
                <option>Lao động</option>
            </select>
        </div>

        <div className="form-group">
            {/* để trống cho cân layout giống hình */}
        </div>

    </div>

    <div className="form-group">
        <label>
            Mô tả <span className="optional">(không bắt buộc)</span>
        </label>

        <textarea
            rows="3"
            placeholder="Nhập mô tả chỉ tiêu"
        />
    </div>

    {/* TRẠNG THÁI */}
    <div className="status-row">

        <div className="status-item">

            <label>Trạng thái</label>

            <div className="switch-wrapper">

                <label className="switch">
                    <input
                        type="checkbox"
                        defaultChecked
                    />
                    <span className="slider"></span>
                </label>

                <span className="status-text">
                    Đang áp dụng
                </span>

            </div>

        </div>

        {/* <div className="status-item">

            <label>Độ ưu tiên</label>

            <input
                type="number"
                min="1"
                placeholder="1"
            />

        </div> */}

    </div>

    <div className="modal-footer">

        <button
            className="outline-btn"
            onClick={() => setShowAddIndicatorModal(false)}
        >
            Hủy
        </button>

        <button className="primary-btn">
            Lưu
        </button>

    </div>

</div>

    </div>

</div>

)}

</div>

      </div>

    </div>
  );
}



export default CongNghiep;